var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "decorative-divider" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c("div", { staticClass: "card-surcharge" }, [
          _c("p", [
            _vm._v(
              "Note: There is a card surcharge of " +
                _vm._s(
                  _vm._f("currency")(_vm.cardSurcharge, _vm.booking.currency)
                )
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-center" }, [
          _vm.errorMessage
            ? _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "#ffb3b7",
                    "padding-top": "0.5em",
                    "padding-bottom": "0.25em",
                    "margin-bottom": "0.5em",
                    "border-radius": "5%",
                    width: "50%",
                  },
                },
                [
                  _c("p", [
                    _c("b", [_vm._v("Error:")]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errorMessage || "Unknown Error") +
                        "\n        "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("payment-pricing-table", {
          attrs: {
            booking: _vm.booking,
            "card-surcharge": _vm.cardSurcharge,
            "payment-amount": _vm.paymentAmount,
          },
        }),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "pin-payment-button btn btn-payment",
            attrs: { click: _vm.pay, "aria-label": "Pay Now" },
          },
          [
            _c("i", { staticClass: "fa fa-lock" }),
            _vm._v(" Securely Pay Now\n    "),
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "stripe-payment" }, [
        _c("div", { attrs: { id: "card-element" } }),
        _vm._v(" "),
        _c("div", { attrs: { id: "cvc-element" } }),
        _vm._v(" "),
        _c("div", { attrs: { id: "exp-element" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "payment-icons" }, [
      _c("img", { attrs: { src: "/static/visa.png", alt: "Visa Card Logo" } }),
      _vm._v(" "),
      _c("img", {
        attrs: { src: "/static/mastercard.png", alt: "MasterCard Logo" },
      }),
      _vm._v(" "),
      _c("img", { attrs: { src: "/static/amex.png", alt: "Amex Logo" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }